import React from "react";
import { Box, Card } from "@mui/material";
import EmptyResult from "../rules/EmptyResult";
import { LTOSetupSkeleton } from "./LTOSetupSkeleton";
import { LTOSetupItem } from "./LTOSetupItem";
import { RoleBundleMapping } from "../../types/models/LTOSetup";

interface LTOSetupListProp {
  LTOSetups: RoleBundleMapping[] | undefined;
  isLoading: boolean;
  onEditLTOSetup: (setup: RoleBundleMapping) => void;
}

export const LTOSetupList: React.FC<LTOSetupListProp> = (prop) => {
  const getLTOSetupList = () => {
    if (prop.isLoading) {
      return <LTOSetupSkeleton />;
    } else if (prop.LTOSetups && prop.LTOSetups.length === 0) {
      return <EmptyResult>No LTO / Role Bundle Setup exist</EmptyResult>;
    } else {
      return (
        <Box>
          {prop.LTOSetups?.map((lto) => (
            <LTOSetupItem key={lto.Id} setup={lto} onEdit={(setup) => prop.onEditLTOSetup(setup)} />
          ))}
        </Box>
      );
    }
  };

  return <Card sx={{ width: "100%" }}>{getLTOSetupList()}</Card>;
};
